import algoliasearch from "algoliasearch/lite";
import { reportError } from "@/helpers/errorHelper";

const algoliaClient = algoliasearch(
  process.env.ALGOLIA_APPLICATION_ID,
  process.env.ALGOLIA_SEARCH_API_KEY
);

export const searchClient = {
  ...algoliaClient,
  search(requests) {
    if ((requests.every(({ params }) => !(params.query))) && (requests.every(({ params }) => !(params.facetFilters)))) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 'zero-result',
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      }).catch(function(error) {
        reportError(error)
        alert("The error is handled, continue normally");
      
      });
    }

    return algoliaClient.search(requests);
  },
};

export const searchClientDefault = algoliaClient;